






























































































































import { Destroyed } from '../../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal,
    Input,
    DatePickerSingle
} from '../../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../../core/mixins';
import { InsuranceServices } from '../../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { editableField, EditableHarvestRanchFields, editRanchEditableField, HarvestRanchEditableFields, HarvestRanchEditableFieldType, ManualHarvestRanchValue, RanchFieldPriority, SatelitalHarvestRanchValue, TelematicHarvestRanchValue } from '../../ranch';
import { getValueByType } from '../../../core/api';
import { calculateSowingDate } from '../../../insurance/api/sowingModels';
import { formattedDate, isNullOrEmpty } from '../../../core/utils';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        Input,
        DatePickerSingle
    }
})
export default class RanchEditableFieldInfo extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() ranchFieldsTypes: object;
    @Prop({default: null}) ranchId: number;
    @Prop({default: null}) fieldInfo: editableField;
    @Prop({default: ''}) fieldType: HarvestRanchEditableFieldType;
    @Prop({default: ''}) fieldLabel: string;
    @Prop({default: null}) sowingRanchLink: null | object;

    radioValue: RanchFieldPriority | null = null;
    telematicValue: string = '';
    manualValue: string = '';
    satelitalValue: string = '';
    dateField: boolean = false;
    modifyingField: boolean = false;
    recalculatingSatellital: boolean = false;
    recalculatingTelematic: boolean = false;
    harvestRanchFieldTypes: object = EditableHarvestRanchFields;
    telematicNeedsLink: Array<string> = [
        this.harvestRanchFieldTypes['sowing_start'],
        this.harvestRanchFieldTypes['resowing_area'],
        this.harvestRanchFieldTypes['resowing_start'],
    ]
    formatDate: Function = formattedDate;

    get visibleTelematicCalculation(){
        if(this.telematicNeedsLink.includes(this.fieldType) && this.sowingRanchLink == null){
            return false
        }
        
        return true
    }

    doNothing(){}

    @Watch('manualValue', {immediate: true, deep: true})
    observableManualValue(value){
        if(!isNullOrEmpty(value) && this.fieldInfo.priority == null){
            this.updateRadioValue(ManualHarvestRanchValue)
        }
    }

    @Watch('fieldInfo', {immediate: true, deep: true})
    observableFieldInfo(){
        this.checkIfFieldIsDate();
        this.loadFieldsValues();
        this.markRadioByPriority();
    }

    
    mounted() {
        this.checkIfFieldIsDate();
        this.loadFieldsValues();
        this.markRadioByPriority();
    }

    checkIfFieldIsDate(){
        if(this.fieldLabel.includes('Fecha')){
            this.dateField = true;
        }
    }

    loadFieldsValues(){
        /* Cargo los valores para los campos */
        this.updateSatelitalValue(this.fieldInfo.satelital);
        this.updateManualValue(this.fieldInfo.manual);
        this.updateTelematicValue(this.fieldInfo.telematic);
    }

    markRadioByPriority(){
        /* Marco el radio button de acuerdo a la prioridad */
        if(this.fieldInfo.priority == null) return
        this.radioValue = this.fieldInfo.priority
    }

    updateRadioValue(value){
        this.radioValue = value;
    }
    updateSatelitalValue(value){
        this.satelitalValue = value;
    }
    updateManualValue(value){
        this.manualValue = value;
    }
    updateTelematicValue(value){
        this.telematicValue = value;
    }

    
    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    calculateSowingDate(value:RanchFieldPriority){
        let self = this;
        let data: calculateSowingDate = {
            id: this.ranchId,
            type: value
        }
        if(value == TelematicHarvestRanchValue){
            this.recalculatingTelematic = true;
        }else{
            this.recalculatingSatellital = true;
        }
        InsuranceServices.calculateSowingDate(
            data
        ).then((res) => {
            this.$_showAddPointOfInterest(res.message);
            this.updateEditableFieldInfo(self.fieldType, res.data);
        }).catch((err)=> {
            this.showCatchLoadingDialog(err, 'No se pudo enviar a recalcular la Fecha de Siembra');
        }).finally(() => {
            this.recalculatingTelematic = false;
            this.recalculatingSatellital = false;
        })
    }

    saveField() {
        this.modifyingField = true;
        let value = this.manualValue;
        let self = this;
        if(this.dateField && value && value.indexOf('T') == -1){
            value += 'T00:00:00';
        }
        let data: editRanchEditableField = {
            ranch_id: this.ranchId,
            priority: this.radioValue as RanchFieldPriority,
            [this.fieldType]: value
        }

        InsuranceServices.editRanchField(
            data
        ).then((res) => {
            this.modifyingField = false;
            this.$_showAddPointOfInterest(res.data.message);
            this.updateEditableFieldInfo(self.fieldType, res.data.data);
            this.closeModal();
        }).catch((err)=> {
            this.modifyingField = false;
            this.showCatchLoadingDialog(err, 'No se pudo editar el campo');
        })
       
    }

    @Emit()
    updateEditableFieldInfo(fieldKey:string, newData: editableField){}

    @Emit()
    updateEditableFields(data: HarvestRanchEditableFields){}

    getValueByPriority(){
        /* Obtengo el valor para enviar a Modificar segun la prioridad*/
        if(this.radioValue == null) return null

        let values = {
            1: this.telematicValue,
            0: this.manualValue,
            2: this.satelitalValue
        }

        return values[this.radioValue]
    }

    getValueParsed(value){
        return getValueByType(value)
    }


    @Emit()
    closeModal() {}

}
